// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__s1zed"};


//////////////////
// WEBPACK FOOTER
// ./components/navigation/style.css
// module id = nBo+
// module chunks = 3